import SharedWorkoutDialog from './SharedWorkoutDialog';

export default SharedWorkoutDialog;
